module.exports = __webpack_public_path__ + "static/media/avatar7.8a991c26.jpg";